import React from 'react';

interface MetricCardProps {
  label: string;
  value: React.ReactNode;
  subtext?: React.ReactNode;
}

const MetricCard: React.FC<MetricCardProps> = ({
  label, value, subtext,
}) => {
  return (
    <div className="an-metric-card">
      <span className="an-metric-label">{label}</span>
      <span className="an-metric-value">{value}</span>
      <div className="an-metric-footer">
        <span className="an-metric-subtext">{subtext ?? <span>&nbsp;</span>}</span>
      </div>
    </div>
  );
};

export default MetricCard;
